import { Controller } from 'react-hook-form'
import * as z from 'zod'

import { FormItem } from '~/shadcn/ui/form/form'
import { CurrencyInput } from '~/@mid_ui-form/currency-input/CurrencyInput'
import { TextTooltip } from '~/@mid_ui/text-tooltip/TextTooltip'
import { FormStep } from '~/@pages_onboarding/investor-analysis/_analysis-form/FormStep'
import { StepTitle } from '~/@pages_onboarding/investor-analysis/_analysis-form/StepTitle'
import { stringNumberSchema } from '~/@pages_onboarding/investor-analysis/_analysis-form/schemas'
import { useFormStepUnsophisticated } from '../../form-step-unsophisticated/useFormStepUnsophisticated'
import { useQuestionsV1 } from '../../../questions'

const step3Schema = z.object({ annualCommitmentsAmount: stringNumberSchema })
export type Step3Data = z.infer<typeof step3Schema>

export function Step3() {
  const { onCompleted, formData } = useFormStepUnsophisticated()
  const { unsophisticated: unsophisticatedQuestions } = useQuestionsV1()

  return (
    <FormStep
      defaultValues={formData}
      schema={step3Schema}
      onStepCompleted={(updatedData) =>
        onCompleted({ ...formData, ...updatedData })
      }
      render={({ control }) => (
        <>
          <StepTitle>
            {unsophisticatedQuestions.annualCommitmentsAmount.question.label}
          </StepTitle>
          <Controller
            name="annualCommitmentsAmount"
            control={control}
            render={({ fieldState, field }) => (
              <FormItem>
                <CurrencyInput
                  autoFocus
                  aria-invalid={!!fieldState?.error}
                  labelText="Výška ročných záväzkov"
                  value={field.value}
                  onChangeValue={field.onChange}
                  className="lg:w-[240px]"
                />
              </FormItem>
            )}
          />
          <div className="flex items-center gap-2">
            <TextTooltip
              text={
                'Výšku záväzkov môžete vypočítať sčítaním hodnôt všetkých vašich dlhov a záväzkov. Zahrňte do toho všetky finančné záväzky, ako sú hypotéky, úvery, nezaplatené účty a iné dlhy.'
              }
              triggerContent="Ako správne vypočítať výšku záväzkov?"
            />
          </div>
        </>
      )}
    />
  )
}
